export default {
  getSubCompetency: (state) => state.subCompetency,
};
